export default class VideoPlayers {
    constructor() {
        if (Electro.DEBUG) {
            console.info('VideoPlayers.contructor()');
        }

        VideoPlayers.initListeners();
    }

    static initListeners() {
        if (Electro.DEBUG) {
            console.info('VideoPlayers.initListeners()');
        }

        $('.js-play-video').one('click', (e) => {
            VideoPlayers.playVideo(e);
        });

        $('.js-play-video').on('keydown', (e) => {
            if (e.key === 'enter' || e.key === ' ') {
                VideoPlayers.playVideo(e);
            }
        });
    }

    static playVideo(e) {
        if (Electro.DEBUG) {
            console.info('VideoPlayers.playVideo()');
        }

        e.preventDefault();

        const youtubeID = $(e.currentTarget).data('video');
        const playerID = `video-player-${youtubeID}`;

        $(e.currentTarget).hide();

        console.info('youtubeID: ', youtubeID);
        console.info('playerID: ', playerID);

        VideoPlayers.onYouTubeIframeAPIReady(youtubeID, playerID);
    }

    static onYouTubeIframeAPIReady(youtubeID, playerID) {
        if (Electro.DEBUG) {
            console.info('VideoPlayers.onYouTubeIframeAPIReady()');
        }

        const player = new YT.Player(playerID, {
            height: '390',
            width: '640',
            videoId: youtubeID,
            playerVars: {
                controls: 1,
                rel: 0,
            },
            events: {
                onReady: VideoPlayers.onPlayerReady,
                onStateChange: VideoPlayers.onPlayerStateChange,
            },
        });
    }

    static onPlayerReady(event) {
        if (Electro.DEBUG) {
            console.info('VideoPlayers.onPlayerReady()');
        }

        event.target.playVideo();
    }

    static onPlayerStateChange(event) {
        if (Electro.DEBUG) {
            console.info('VideoPlayers.onPlayerStateChange()');
        }

        switch (event.data) {
            case -1:
                console.info('video unstarted');
                break;
            case 0:
                console.info('video ended');
                break;
            case 1:
                console.info('video playing');
                break;
            case 2:
                console.info('video paused');
                break;
            case 3:
                console.info('video buffering');
                break;
            case 5:
                console.info('video cued');
                break;
            default:
        }
    }
}
